import {
    HttpErrorResponse,
    HttpInterceptorFn,
    HttpResponse,
} from "@angular/common/http";
import { Game } from "@Front-end/seed/models/game";
import { SearchResult } from "@Front-end/seed/models/search";
import {
    catchError,
    map,
    Observable,
    throwError,
} from "rxjs";
import { sportGameId } from "../../constants/sporting.constants";

export const sportbookGamesInterceptor: HttpInterceptorFn = (req, next) => {
    const gameUrl: string = "game/list";
    const searchUrl: string = "/search";
    const gameId: number = sportGameId;

    return next(req).pipe(
        map((event) => {
            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { result: unknown })?.result
                && req.url.includes(gameUrl)
            ) {
                // @ts-ignore
                const updatedGames: Game[] = (<Game[]> event.body.result)
                    .filter((item: Game) => item.game_id !== gameId);
                // @ts-ignore
                event = event.clone({ body: { ...event.body, result: updatedGames } });
            }

            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { games: unknown })?.games
                && req.url.includes(searchUrl)
            ) {
                // @ts-ignore
                const updatedGames: Game[] = (<Game[]> event.body.games.result)
                    .filter((item: Game) => item.game_id !== gameId);
                const updatedResult: SearchResult = {
                    // @ts-ignore
                    ...event.body,
                    games: {
                        // @ts-ignore
                        ...event.body.games,
                        result: updatedGames,
                    },
                };
                event = event.clone({
                    // @ts-ignore
                    body: { ...event.body, ...updatedResult },
                });
            }

            return event;
        }),
        catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
    );
};
